// 登录相关
import RequestUtils from "@/request";

const url = `/index/mobile`;

class LoginService {

    /**
     * @description 账号密码登录
     * @param {Object} data
     * @param {String} data.loginName
     * @param {String} data.password
     */
    login(data) {
        return RequestUtils.post({
            url: `${url}/login`,
            data
        })
    }

    /** 退出登录 */
    logout() {
        return RequestUtils.get({
            url: `${url}/logout`
        })
    }

}

export default new LoginService();